// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1QeG4","header":"MessagesList_header__AjD7X","chat":"MessagesList_chat__1WrLQ"};